
import React from 'react';

const ContactHeader = () => {
  return (
    <div className="text-center max-w-3xl mx-auto mb-16">
      <span className="inline-block px-4 py-1.5 mb-6 text-xl font-medium rounded-full bg-primary/10 text-primary">
        Get In Touch
      </span>
      <h2 className="text-4xl md:text-5xl font-serif font-semibold tracking-tight text-foreground mb-6">
        Ready to Experience Premium Spitbraai Catering?
      </h2>
      <p className="text-lg text-muted-foreground">
        Plan your perfect event with our custom spitbraai packages, or get in touch with any questions 
        about our services. We're here to help make your occasion unforgettable.
      </p>
    </div>
  );
};

export default ContactHeader;
